import {Card, Pagination, Table} from "antd";
import {renderDate} from "../../../../utils";
import {Button, PopperUserInfo, StatusLabel, Image, FontAwesomeIcon} from "../../../../components";
import RequestDemoAction from "./RequestDemoAction";
import {useState} from "react";
import Paragraph from "antd/es/typography/Paragraph";

function RequestDemoTable({items = [], pagination, onPaginationChange, can, setItemEdit, handleStatus, openModal, onHandleLoginHost, onHandleLoginDb, onHandleFtpCreated})
{
    const [ftpAccounts, setFtpAccounts] = useState({});

    const columns = [
        { title: 'Nhân viên', dataIndex: 'user', key: "user", width: '150px', render: (_, item) => (
                item.user?.id &&
                <PopperUserInfo user={item.user}>
                    <div className="d-flex gap align-items">
                        <div className="avatar"><Image src={item.user?.avatar} /></div>
                        <div>
                            <b>{item.user?.lastname}</b>
                            <p>{item.user?.username}</p>
                        </div>
                    </div>
                </PopperUserInfo>
            )},
        { title: 'Nhân viên share', dataIndex: 'userShare', key: "userShare", width: '150px', render: (_, item) => (
                item?.userShare?.id &&
                <PopperUserInfo user={item.userShare}>
                    <div className="d-flex gap align-items">
                        <div className="avatar"><Image src={item.userShare?.avatar} /></div>
                        <div>
                            <b>{item.userShare?.lastname}</b>
                            <p>{item.userShare?.username}</p>
                        </div>
                    </div>
                </PopperUserInfo>
            )},
        {
            title: "Khách hàng",
            dataIndex: "customer",
            key: "customer",
            width: 250,
            render: (_, item) => {
                return (<span>{item.customer.name}</span>)
            }
        },
        {
            title: "Liên kết demo",
            dataIndex: "url",
            key: "url",
            render: (_, item) => {
                return (<span>{item.url}</span>)
            }
        },
        {
            title: "Ngày tạo",
            dataIndex: "created",
            key: "created",
            render: (_, item) => {
                return <span>{renderDate(item.created)}</span>;
            }
        },
        {
            title: "Tình trạng",
            dataIndex: "status",
            key: "status",
            width: 150,
            render: (_, item) => {
                return <span><StatusLabel type={item.status.badge}>{item.status.label}</StatusLabel></span>;
            }
        },
        {
            title: '#',
            dataIndex: 'action',
            key: "action",
            width: '220px',
            render: (_, item) => {
                return <RequestDemoAction
                    item={item}
                    can={can}
                    handleStatus={handleStatus}
                    openModal={openModal}
                    setItemEdit={setItemEdit}
                />
            }
        }
    ]

    const dataSource= items.map(row => ({
        key: row.id, // I added this line
        ...row
    }));

    return (
        <div className="table-wrapper">
            <div className="table-box">
                <Table columns={columns} dataSource={dataSource} scroll={{ y:550 }} pagination={false} />
            </div>
            <Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
        </div>
    )
}

export default RequestDemoTable;